import Vue from 'vue'
import moment from 'moment'
import { ADD_TOAST_MESSAGE } from 'vuex-toast'
import { ScriptTemplatesAction } from '@/store/modules/script-templates/actions'
import { RouteNames } from '@/router'

import type { RawLocation } from 'vue-router'
import type { ScriptTemplate } from '@/models/scriptTemplates'

interface Data {
  cloneInProgress: boolean
}

interface Methods {
  handleClone: () => Promise<void>
  handleClickTag: (tag: string) => void
}

interface Computed {
  tags: string[]
  date: string
  previewRoute: RawLocation
}

interface Props {
  scriptTemplate: ScriptTemplate
}

export default Vue.extend<Data, Methods, Computed, Props>({
  props: {
    scriptTemplate: {
      required: true,
    }
  },
  data() {
    return {
      cloneInProgress: false
    }
  },
  computed: {
    tags(): string[] {
      return this.scriptTemplate.tags.map(tag => `#${tag}`)
    },
    date(): string {
      return moment(this.scriptTemplate.date).format('DD.MM.YYYY')
    },
    previewRoute(): RawLocation {
      return { name: RouteNames.ScriptPage, params: { scriptId: this.scriptTemplate.script_id } }
    }
  },
  methods: {
    async handleClone(): Promise<void> {
      try {
        if (this.cloneInProgress) {
          return
        }

        this.cloneInProgress = true
        const response = await this.$store.dispatch(ScriptTemplatesAction.useScriptTemplate, this.scriptTemplate.id)
        
        if (response) {
          this.$store.dispatch(ADD_TOAST_MESSAGE, {
            text: this.$tc('script.actions.copySuccess'),
            type: 'info',
          })
        }

        this.cloneInProgress = false
      } catch (e) {
        this.cloneInProgress = false
      }
    },
    handleClickTag(tag: string) {
      this.$emit('click-tag', tag)
    }
  } 
})
